import { render } from "./ViewSubmissionDialog.vue?vue&type=template&id=628fa079&scoped=true"
import script from "./ViewSubmissionDialog.vue?vue&type=script&lang=js"
export * from "./ViewSubmissionDialog.vue?vue&type=script&lang=js"

import "./ViewSubmissionDialog.vue?vue&type=style&index=0&id=628fa079&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628fa079"]])

export default __exports__